const API_BASE_URL = "https://api-dpl-684526581556.asia-south1.run.app";

export const API_ENDPOINTS = {
  TEAMS_LEADERBOARD: `${API_BASE_URL}/teams/leaderboard`,
};

export default API_BASE_URL;
